export default __webpack_public_path__ + "static/media/lines-splines-run.f739d0b2.jpg";